import type { SxProps, Theme } from '@mui/material/styles';

/** Contenido de la página: bloques uno debajo del otro, sin desbordar a los lados. */
export const pageSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  minWidth: 0,
  maxWidth: '100%',
};

/** Filtros en una fila: se reparten el ancho y bajan de línea en pantallas pequeñas. */
export const filterGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(min(220px, 100%), 1fr))',
  gap: 2,
  alignItems: 'center',
};

/** Campos de formulario: una columna en teléfono y dos desde tableta. */
export const formGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
  gap: 2,
};

/** Indicadores arriba de una tabla. */
export const statGridSx: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', sm: 'repeat(auto-fit, minmax(200px, 1fr))' },
  gap: 2,
};

/** Tarjeta de sección (filtros o parte de un formulario). */
export const sectionSx: SxProps<Theme> = { p: { xs: 2, sm: 3 }, minWidth: 0 };

/** Formularios: ancho máximo para que no se estiren en monitores grandes. */
export const formMaxWidthSx: SxProps<Theme> = { width: '100%', maxWidth: 1100 };

/** Barra de acciones de un formulario: abajo a la derecha. */
export const formActionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: 1,
};
